import { CheckCircleOutlineRounded, ErrorOutlineOutlined } from "@mui/icons-material";
import QueryBuilderOutlinedIcon from '@mui/icons-material/QueryBuilderOutlined';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { CircularProgressProps } from "@mui/material/CircularProgress";
import { Property } from "csstype";
import { CircularProgressWithLabel } from "../Loading/CircularProgressWithLabel";

export interface SummarizeProgressData {
    importTypeId: number;
    importName: string;
    numberOfRowsCorrect: number;
    numberOfRowsFailed: number;
    isSuccess: boolean;
}

const defaultIconSize = 45;

export function ImportProgressBarSummarize(props: CircularProgressProps & { value: number } & { progressData: SummarizeProgressData }
    & { iconHeight?: Property.Height<string | number> | undefined } & { iconWidth?: Property.Width<string | number> | undefined }) {

    const iconWidth = props.iconWidth ?? defaultIconSize;
    const iconHeight = props.iconHeight ?? defaultIconSize;

    const tile = (icon: React.ReactNode, caption: string) => (
        <Grid container item key={props.progressData?.importTypeId} xs={12} sm={6} md={3} alignItems="center">
            <Stack direction="row" spacing={2} alignItems="center" sx={{ minWidth: 0, width: '100%' }}>
                <Box sx={{ flexShrink: 0, width: iconWidth, height: iconHeight, display: 'flex', alignItems: 'center' }}>
                    {icon}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', minWidth: 0 }}>
                    <Typography variant="body2" sx={{ mb: 0, fontWeight: 'regular' }} color="secondary">
                        {props.progressData?.importName}
                    </Typography>
                    <Typography variant="caption" sx={{ mt: 0, fontStyle: 'italic' }} color="secondary">
                        {caption}
                    </Typography>
                </Box>
            </Stack>
        </Grid>
    );

    return (
        <>
            {props.progressData?.isSuccess && props.progressData?.numberOfRowsCorrect === 0 && props.value < 100 && tile(
                props.value === 0
                    ? <QueryBuilderOutlinedIcon color="secondary" style={{ width: iconWidth, height: iconHeight }} />
                    : <CircularProgressWithLabel value={props.value} width={iconWidth} height={iconHeight} />,
                props.value === 0 ? 'Import queued' : 'Import in progress'
            )}

            {!props.progressData?.isSuccess && tile(
                <ErrorOutlineOutlined color="error" style={{ width: iconWidth, height: iconHeight }} />,
                'Import failed'
            )}

            {props.progressData?.isSuccess && (props.progressData?.numberOfRowsCorrect > 0 || props.value >= 100) && tile(
                <CheckCircleOutlineRounded color="success" style={{ width: iconWidth, height: iconHeight }} />,
                props.progressData?.numberOfRowsCorrect === 0
                    ? 'No matching records for this scorecard'
                    : `All ${props.progressData?.numberOfRowsCorrect} records imported`
            )}
        </>
    );
}
